import { IS_DEV } from '../../../service/api';
import { mockConcertData, getRandomMockData } from './mockData';

export const loadMockData = (artist) => {
  if (!IS_DEV) return null;
  
  if (artist === 'coldplay') {
    return mockConcertData.coldplay;
  } else if (artist === 'dualipa') {
    return mockConcertData.duaLipa;
  } else {
    // Return random data if no specific artist requested
    return getRandomMockData();
  }
};

export const populateFormWithMockData = (data, setFormData, setEquipmentItems, setMaintenanceHistory, setUpcomingEvents, setSystemInteractions, setPastIssues) => {
  if (!data) return;
  
  // Set venue profile data
  setFormData(prevData => ({
    ...prevData,
    'venue-profile': data.venueProfile
  }));
  
  // Set equipment items
  setEquipmentItems(data.equipmentItems);
  
  // Set maintenance history
  setMaintenanceHistory(data.maintenanceHistory);
  
  // Set upcoming events
  setUpcomingEvents(data.upcomingEvents);
  
  // Set system interactions
  setSystemInteractions(data.systemInteractions);
  
  // Set past issues
  setPastIssues(data.pastIssues);
};